/**
 * Tablist controller.
 *
 * This class controls site tablists
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class TabList {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.tablistPanesById = {};
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$tabs = $( '.js-tablist__tab' );

        // Save an object of all tablist panes.
        $( '.js-tablist__pane' ).each( ( index, element ) => {
            if ( element.id ) {
                this.tablistPanesById[element.id] = element;
            }
        });
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Every tab in the tablist needs to be clickable and
        // when clicked, activates the corresponding pane.
        this.$tabs.each( ( index, tab ) => {
            $( tab ).on( 'click', ( e ) =>  {
                this.tabClickHandle( e, tab );
            });
        });
    }

    /**
     * Handles toggling of tab items.
     *
     * @param {event object} e
     * @param {dom node} accordionHeading
     */
    tabClickHandle( e, tab ) {
        Theme.Common.stop( e );

        const $tab = $( tab );

        // Return early if this is already active.
        if ( $tab.hasClass( 'tablist__tab--selected' ) ) {
            return;
        }

        // Get the container of the tabs.
        const $tabList = $tab.closest( '.js-tablist__tabs' );

        this.toggleTab( $tab );

        // Close all other open tabs.
        $tabList.find( '.tablist__tab--selected' ).not( $tab ).each( ( index, element ) => {
            this.toggleTab( $( element ) );
        });
    }

    /**
     * This handles the toggling of the accordion elements' visibility and aria classes.
     *
     * @param {obj} accordionHeading jQuery object.
     */
    toggleTab( $tab ) {
        const paneId = $tab.attr( 'aria-controls' );
        const tabState = $tab.attr( 'aria-selected' ) === 'false' ? true : false;

        // Set the tab classes and aria-attributes.
        $tab.toggleClass( 'tablist__tab--selected' );
        $tab.attr( 'aria-selected', tabState );

        // Return early if no paneId found
        if ( ! paneId ) {
            return;
        }

        // Return early if no element with that id found
        if ( this.tablistPanesById[paneId] === undefined ) {
            return;
        }

        const $pane = $( this.tablistPanesById[paneId]);

        // Set the pane classes and aria-attributes.
        $pane.toggleClass( 'tablist__pane--active' );
        $pane.attr( 'aria-hidden', tabState );
    }

    /**
     * Run when the document is ready.
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
    }
}
